// WHOLESALE PRICING SYSTEM - JavaScript
// English Version
// Logic for displaying wholesale prices based on customer tags and login status

document.addEventListener('DOMContentLoaded', function() {
  // Check if user is logged in
  const customer = window.Shopify && window.Shopify.customer;
  
  if (customer && customer.tags) {
    // Get customer tags
    const customerTags = customer.tags.split(',').map(tag => tag.trim().toLowerCase());
    
    // Check if customer is Reseller or End User
    const isReseller = customerTags.includes('reseller');
    const isEndUser = customerTags.includes('end_user');
    
    // Add class to body for CSS rules
    if (isReseller) {
      document.body.classList.add('customer-reseller');
      applyWholesalePricing('reseller');
    } else if (isEndUser) {
      document.body.classList.add('customer-end-user');
      applyWholesalePricing('end_user');
    }
  }
});

function applyWholesalePricing(customerType) {
  // Apply wholesale pricing based on customer type
  
  if (customerType === 'reseller') {
    // Add classes for wholesale price styling
    const productForm = document.querySelector('[data-product-id]');
    if (productForm) {
      productForm.classList.add('is-wholesale');
      
      // Can add custom messages here
      const priceSection = document.querySelector('[role="status"]');
      if (priceSection) {
        console.log('Wholesale pricing applied for reseller');
      }
    }
  }
}




